/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_Google_RequiredInputs */

const cs_youtube_export_google_required = /** @type {(inputs: Youtube_Export_Google_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Před exportem propojte Google v profilu (s oprávněním YouTube).`)
};

const en_youtube_export_google_required = /** @type {(inputs: Youtube_Export_Google_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Google in profile settings (with YouTube permission) before exporting.`)
};

/**
* | output |
* | --- |
* | "Connect Google in profile settings (with YouTube permission) before exporting." |
*
* @param {Youtube_Export_Google_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_google_required = /** @type {((inputs?: Youtube_Export_Google_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_Google_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_google_required(inputs)
	return cs_youtube_export_google_required(inputs)
});